export const NEWS_FAILED = 'loading_news_has_failed';
export const NEWS_LOADED = 'set_loaded_news';
export const LOAD_NEWS = 'load_news';
